exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/tip-card-change/TripPaymentCardsDetailsVFError/TripPaymentCardsDetailsVFError.component.css
// module id = ../../../../../src/app/tip-card-change/TripPaymentCardsDetailsVFError/TripPaymentCardsDetailsVFError.component.css
// module chunks = main